var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "21px",
    viewBox: "0 0 33 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-67.000000, -64.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header_virtual_terminal",
    transform: "translate(52.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "praxis_logo",
    transform: "translate(15.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 13.91,
    y: 11.4,
    width: 2.42,
    height: 3.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 16.26,
    y: 11.4,
    width: 2.35,
    height: 3.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.08,11 C1.14,11 1.08,11 1.08,11 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.55,11.3 L14.14,7.71 C14.0785849,7.02831949 13.9341836,6.35668528 13.71,5.71 C13.4360555,4.87717658 13.041892,4.08884964 12.54,3.37 C11.4377048,1.97130397 9.84879274,1.03938026 8.09,0.76 C7.79,0.76 7.47,0.71 7.09,0.71 C6.5067093,0.708539168 5.92443504,0.758735225 5.35,0.86 C2.2188453,1.61943955 0.0104785554,4.41808001 -2.80984546e-16,7.64 C-0.0022654106,8.2547026 0.0784636055,8.86689764 0.24,9.46 C0.614143136,10.6584349 1.26108653,11.7537888 2.13,12.66 C3.43568459,13.9221282 5.18406194,14.6221971 7,14.61 C5.12,14.61 11.5,14.61 11.71,14.61 C11.71,14.61 11.83,14.61 11.71,14.61 L12.27,19.74 C12.3578276,20.1776471 12.7250741,20.5040884 13.17,20.54 L14.78,20.54 C15.1614202,20.4814198 15.4447029,20.1558561 15.45,19.77 C15.42,19.1 14.55,11.3 14.55,11.3 Z M7,11.4 C6.04387614,11.3804729 5.13006017,11.002096 4.44,10.34 C3.97618635,9.85317752 3.63359758,9.26392484 3.44,8.62 C3.34876002,8.29466145 3.30497492,7.95785301 3.31,7.62 C3.32497401,5.88851756 4.52350578,4.39241928 6.21,4 C6.5392177,3.93475578 6.87442318,3.90458728 7.21,3.91 C7.37983688,3.89946806 7.55016312,3.89946806 7.72,3.91 C8.66604556,4.0625804 9.52151381,4.56160354 10.12,5.31 C10.3910766,5.69658038 10.6033817,6.12119046 10.75,6.57 C10.8789481,6.92822834 10.9629237,7.30107983 11,7.68 L11.21,9.61 L11.4,11.35 L7,11.4 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.43,11 C31.36,11 31.43,11 31.43,11 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.15,0.86 C26.5591762,0.755363517 25.9599984,0.705153084 25.36,0.71 C25.0460264,0.710890285 24.7322964,0.727578049 24.42,0.76 C22.6735404,1.04391073 21.0966851,1.97147263 20,3.36 C19.4875869,4.07703865 19.0832719,4.86545303 18.8,5.7 C18.5701343,6.34560346 18.4223096,7.0175342 18.36,7.7 L18,11.3 C18,11.3 17.13,19.1 17.13,19.77 C17.1352971,20.1558561 17.4185798,20.4814198 17.8,20.54 L19.41,20.54 C20.14,20.54 20.31,19.74 20.31,19.74 L20.87,14.61 C20.75,14.61 20.87,14.61 20.87,14.61 C21.07,14.61 27.45,14.61 25.58,14.61 C27.3823176,14.6128116 29.1148287,13.9133506 30.41,12.66 C31.2858149,11.7590425 31.9337896,10.6619426 32.3,9.46 C32.4615364,8.86689764 32.5422654,8.2547026 32.54,7.64 C32.5250546,4.40631066 30.2970379,1.60372195 27.15,0.86 Z M29.05,8.62 C28.8553698,9.26347634 28.512913,9.85250205 28.05,10.34 C27.3646605,11.0031351 26.4534731,11.3819032 25.5,11.4 L21.14,11.4 L21.33,9.66 L21.55,7.73 C21.578625,7.35816548 21.6559527,6.99169955 21.78,6.64 C21.9308226,6.19292899 22.1428367,5.76890066 22.41,5.38 C23.0084862,4.63160354 23.8639544,4.1325804 24.81,3.98 C24.9798369,3.96946806 25.1501631,3.96946806 25.32,3.98 C25.6555768,3.97458728 25.9907823,4.00475578 26.32,4.07 C28.0133814,4.46898251 29.2099746,5.98025068 29.21,7.72 C29.1918568,8.02520241 29.1381603,8.32724507 29.05,8.62 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cc65899f471aaba287781b7ac37cb54d.svg";
export { ForwardRef as ReactComponent };